import * as React from "react";
import { Context } from "./_context";
export const RecenterIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 3a1 1 0 0 1 .895.553l8 16 .06.15a1 1 0 0 1-1.442 1.17L12 16.683l-7.513 4.19a1.001 1.001 0 0 1-1.382-1.32l8-16 .072-.121A1 1 0 0 1 12 3ZM6.344 17.547l5.169-2.882.116-.056c.277-.11.593-.092.858.056l5.168 2.882L12 6.237l-5.656 11.31Z", fill: "currentColor" }));
  return iconset[size];
};
RecenterIcon.iconId = "XvGD5I";
